import Login from 'pages/login';
import ReservationBookingOnline from 'pages/reservationBookingOnline';
import ReservationBookingOnlineV2 from 'pages/reservationBookingOnlineV2';
import FinishBooking from 'pages/reservationBookingOnline/page/FinishBookingPage';
import ConfirmBooking from 'pages/reservationBookingOnline/page/ConfirmBookingPage';
import ReservationChange from 'pages/reservationChange';
import DateChangePage from 'pages/reservationChange/DateChangePage';
import ReservationChangeConfirmPage from 'pages/reservationChange/ReservationChangeConfirmPage';
import ReservationChangeCompletePage from 'pages/reservationChange/ReservationChangeCompletePage';
import MenuReselectPage from 'pages/reservationChange/MenuReselectPage';
import MenuReselectDatePage from 'pages/reservationChange/MenuReselectDatePage';
import MenuReselectConfirmPage from 'pages/reservationChange/MenuReselectConfirmPage';
import { lazy } from 'react';
import ChangePassword from 'pages/changePassword';
import { PrivateRouteType } from './type';
/**
 * Login is not required
 * Note: sub-routes is not supported
 */
export const publicRoutes = [
  {
    path: '/login',
    title: 'Login',
    loadComponent: Login,
  },
  {
    path: '/changePassword',
    title: 'パスワード変更',
    loadComponent: ChangePassword,
  },
  {
    path: '/contact/reservem/',
    title: '',
    loadComponent: ReservationBookingOnline,
  },
  {
    path: '/contact/reserve/',
    title: '',
    loadComponent: ReservationBookingOnline,
  },
  {
    path: '/contact/finish/',
    title: '仮予約完了',
    loadComponent: FinishBooking,
  },
  {
    path: '/contact/confirm/',
    title: '予約確認',
    loadComponent: ConfirmBooking,
  },
  {
    path: '/contact/reserveNew',
    title: 'ご予約までの流れ',
    loadComponent: ReservationBookingOnlineV2,
  },
  {
    path: '/contact/reservationChange',
    title: '予約変更・キャンセル',
    loadComponent: ReservationChange,
  },
  {
    path: '/contact/reservationChangeDateChange',
    title: '日時を変更',
    loadComponent: DateChangePage,
  },
  {
    path: '/contact/reservationChangeConfirm',
    title: 'ご予約内容確認',
    loadComponent: ReservationChangeConfirmPage,
  },
  {
    path: '/contact/reservationChangeComplete',
    title: '受付完了',
    loadComponent: ReservationChangeCompletePage,
  },
  {
    path: '/contact/reservationMenuReselect',
    title: 'メニューから再選択',
    loadComponent: MenuReselectPage,
  },
  {
    path: '/contact/reservationMenuReselectDate',
    title: 'メニューから再選択 - 日時選択',
    loadComponent: MenuReselectDatePage,
  },
  {
    path: '/contact/reservationMenuReselectConfirm',
    title: 'メニューから再選択 - 確認',
    loadComponent: MenuReselectConfirmPage,
  },
];

/**
 * Login required
 */
export const privateRoutes: PrivateRouteType[] = [
  {
    title: '',
    path: '',
    hasAppbar: false,
    loadComponent: lazy(() => import('pages/home')),
  },
  {
    title: 'パスワード更新確認',
    path: '/comfirmChangePassword',
    hasAppbar: false,
    loadComponent: lazy(() => import('pages/confirmChangePassword')),
  },
  // executiveMaster
  {
    title: '役職マスタ一覧',
    path: '/executiveMaster',
    loadComponent: lazy(() => import('pages/executiveMaster')),
    subRoutes: [
      {
        title: '新規役職マスタ作成',
        path: '/add',
        loadComponent: lazy(() => import('pages/executiveMaster/add')),
      },
      {
        title: '役職マスタ編集',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/executiveMaster/add')),
      },
    ],
  },
  // orgMaster
  {
    title: '組織マスタ一覧',
    path: '/orgMaster',
    loadComponent: lazy(() => import('pages/orgMaster')),
    subRoutes: [
      {
        title: '新規組織マスタ作成',
        path: '/add',
        loadComponent: lazy(() => import('pages/orgMaster/add')),
      },
      {
        title: '組織マスタ編集',
        path: '/edit/:id/:applyStartDate',
        loadComponent: lazy(() => import('pages/orgMaster/add')),
      },
    ],
  },
  // Staff Master
  {
    title: 'スタッフマスタ一覧',
    path: '/staffMaster',
    loadComponent: lazy(() => import('pages/staffMaster')),
    subRoutes: [
      {
        title: 'スタッフマスタ',
        path: '/add',
        loadComponent: lazy(() => import('pages/staffMaster/add')),
      },
      {
        title: 'スタッフマスタ',
        path: '/edit/:id/:applyStartDate',
        loadComponent: lazy(() => import('pages/staffMaster/add')),
      },
    ],
  },
  // Role Master
  {
    title: '権限マスタ',
    path: '/roleMaster',
    loadComponent: lazy(() => import('pages/roleMaster')),
    subRoutes: [
      {
        title: '権限マスタ・基本マスタ設定',
        path: '/add',
        loadComponent: lazy(() => import('pages/roleMaster/basicMasterSetting')),
      },
      {
        title: '権限マスタ・基本マスタ設定',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/basicMasterSetting')),
      },
      {
        title: '権限マスタ・顧客管理',
        path: '/customerManagement',
        loadComponent: lazy(() => import('pages/roleMaster/customerManagement')),
        subRoutes: [
          {
            title: '権限マスタ・顧客管理',
            path: '/add',
            loadComponent: lazy(() => import('pages/roleMaster/customerManagement')),
          },
          {
            title: '権限マスタ・顧客管理',
            path: '/edit/:id',
            loadComponent: lazy(() => import('pages/roleMaster/customerManagement')),
          },
        ],
      },
      {
        title: '権限マスタ・共通マスタ設定',
        path: '/commonManagement/add',
        loadComponent: lazy(() => import('pages/roleMaster/commonManagement')),
      },
      {
        title: '権限マスタ・共通マスタ設定',
        path: '/commonManagement/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/commonManagement')),
      },
      {
        title: '権限マスタ・予約管理',
        path: '/reservationManagement/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/reservationManagement')),
      },
      {
        title: '権限マスタ・予約管理',
        path: '/reservationManagement/add',
        loadComponent: lazy(() => import('pages/roleMaster/reservationManagement')),
      },
      {
        title: '権限マスタ・レジ管理',
        path: '/cashierManegement/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/cashRegisterManagement')),
      },
      {
        title: '権限マスタ・レジ管理',
        path: '/cashierManegement/add',
        loadComponent: lazy(() => import('pages/roleMaster/cashRegisterManagement')),
      },
      {
        title: '権限マスタ',
        path: '/contractManagement/add',
        loadComponent: lazy(() => import('pages/roleMaster/contractManagement')),
      },
      {
        title: '権限マスタ・契約管理',
        path: '/contractManagement/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/contractManagement')),
      },
      {
        title: '権限マスタ・売上管理',
        path: '/revenueManagement/add',
        loadComponent: lazy(() => import('pages/roleMaster/revenueManagement')),
      },
      {
        title: '権限マスタ・売上管理',
        path: '/revenueManagement/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/revenueManagement')),
      },
      {
        title: '在庫管理権限設定',
        path: '/inventoryManagement/add',
        loadComponent: lazy(() => import('pages/roleMaster/inventoryManagement')),
      },
      {
        title: '在庫管理権限設定',
        path: '/inventoryManagement/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/inventoryManagement')),
      },
      {
        title: 'メルマガ権限設定',
        path: '/mailManagement/add',
        loadComponent: lazy(() => import('pages/roleMaster/mailManagement')),
      },
      {
        title: 'メルマガ権限設定',
        path: '/mailManagement/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/mailManagement')),
      },
      {
        title: '権限マスタ・稟議管理',
        path: '/approvalManagement/add',
        loadComponent: lazy(() => import('pages/roleMaster/approvalManagement')),
      },
      {
        title: '権限マスタ・稟議管理',
        path: '/approvalManagement/edit/:id',
        loadComponent: lazy(() => import('pages/roleMaster/approvalManagement')),
      },
    ],
  },
  // Customer
  {
    title: ' 顧客情報一覧',
    path: '/customer',
    loadComponent: lazy(() => import('pages/customer')),
    subRoutes: [
      {
        title: '顧客情報',
        path: '/detail/:id',
        loadComponent: lazy(() => import('pages/customer/detail')),
        subRoutes: [
          {
            title: '顧客情報',
            path: '/purchaseId/:purchaseId',
            loadComponent: lazy(() => import('pages/customer/detail/reservationHistoryT8/edit')),
          },
          {
            title: '顧客情報',
            path: '/ticketDigestion/:ticketDigestionId',
            loadComponent: lazy(() => import('pages/customer/detail/ticketDigestionHistoryT7/edit')),
          },
          {
            title: '顧客登録',
            path: '/edit',
            loadComponent: lazy(() => import('pages/customer/detail/customerDetailsT1/edit')),
          },
          {
            title: '顧客情報',
            path: '/accountingHistory/:accountId',
            loadComponent: lazy(() => import('pages/customer/detail/accountingHistoryT5/edit')),
          },
          {
            title: 'フェイシャル登録',
            path: '/electronicMedicalRecord',
            loadComponent: lazy(() => import('pages/customer/detail/electronicMedicalRecord/edit')),
          },
          {
            title: '伝達欄登録',
            path: '/editCommunication',
            loadComponent: lazy(() => import('pages/customer/detail/communication/add')),
          },
        ],
      },
      {
        title: '顧客詳細検索',
        path: '/advancedSearch',
        loadComponent: lazy(() => import('pages/customer/advancedSearch')),
      },
      {
        title: '顧客登録',
        path: '/add',
        loadComponent: lazy(() => import('pages/customer/add')),
      },
      {
        title: '顧客情報インポート',
        path: '/import',
        loadComponent: lazy(() => import('pages/customer/import')),
      },
    ],
  },
  {
    title: '雇用形態マスタ一覧',
    path: '/employmentMaster',
    loadComponent: lazy(() => import('pages/employmentMaster/list')),
    subRoutes: [
      {
        title: '雇用形態マスタ作成',
        path: '/add',
        loadComponent: lazy(() => import('pages/employmentMaster/add')),
      },
      {
        title: '雇用形態マスタ編集',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/employmentMaster/add')),
      },
    ],
  },
  {
    title: '写真比較',
    path: '/photoComparison',
    loadComponent: lazy(() => import('pages/customer/detail/imageList/pages/ImageComparision')),
    hasNotSidebar: true,
  },
  {
    title: '顧客番号フォーマット設定',
    path: '/formatNumber',
    loadComponent: lazy(() => import('pages/formatNumber')),
    subRoutes: [],
  },
  {
    title: '申請番号フォーマット設定',
    path: '/formatNumberApproval',
    loadComponent: lazy(() => import('pages/formatNumberApproval')),
    subRoutes: [],
  },
  {
    title: '予約詳細',
    path: '/reservationDetail',
    loadComponent: lazy(() => import('pages/reservationDetail')),
  },
  {
    title: '',
    path: '/reservationPrint',
    loadComponent: lazy(() => import('pages/reservationDashboard')),
    hasNotSidebar: true,
  },
  {
    title: '予約表 [ 恵比寿店 ]',
    path: '/reservation',
    loadComponent: lazy(() => import('pages/reservationDashboard')),
    subRoutes: [
      {
        title: '予約フォーム（店舗用）',
        path: '/oldCustomer/:id?',
        loadComponent: lazy(() => import('pages/reservationForm')),
      },
      {
        title: '予約フォーム（店舗用) ',
        path: '/newCustomer',
        loadComponent: lazy(() => import('pages/reservationForm/add')),
      },
      {
        title: '予約フォーム（店舗用）',
        path: '/reservationInquireCustomer',
        loadComponent: lazy(() => import('pages/reservationForm/inquireCustomer')),
      },
      {
        title: '予約一覧',
        path: '/list',
        loadComponent: lazy(() => import('pages/reservationList')),
        subRoutes: [
          {
            title: '予約詳細',
            path: '/edit',
            loadComponent: lazy(() => import('pages/reservationDetail')),
          },
        ],
      },
    ],
  // Common Master Setting - 共通マスタ
  },
  {
    title: 'メニュー分類マスタ',
    path: '/menuClassificationMaster',
    loadComponent: lazy(() => import('pages/commonMasterSetting/menuClassificationMaster/list')),
  },
  {
    title: 'コース分類マスタ',
    path: '/courseGroupMaster',
    loadComponent: lazy(() => import('pages/courseMaster/courseGroupMaster')),
  },
  {
    title: 'コースカテゴリマスタ',
    path: '/courseCategoryMaster',
    loadComponent: lazy(() => import('pages/courseMaster/courseCategoryMaster')),
  },
  {
    title: 'コースマスタ',
    path: '/courseMaster',
    loadComponent: lazy(() => import('pages/courseMaster')),
    subRoutes: [
      {
        title: 'コースマスタ編集',
        path: '/add',
        loadComponent: lazy(() => import('pages/courseMaster/add')),
      },
      {
        title: 'コースマスタ編集',
        path: '/edit/:contractCourseId',
        loadComponent: lazy(() => import('pages/courseMaster/add')),
      },
    ],
  },
  {
    title: 'メニューマスタ',
    path: '/menuMaster',
    loadComponent: lazy(() => import('pages/commonMasterSetting/menuMaster/list')),
  },
  {
    title: '店舗設定',
    path: 'reservationManagement',
    loadComponent: lazy(() => import('pages/reservationManagement/storeSetting')),
    subRoutes: [
      {
        title: '店舗設定',
        path: '/storeSetting/:orgId?',
        loadComponent: lazy(() => import('pages/reservationManagement/storeSetting')),
      },
      {
        title: '予約コース設定・既存顧客',
        path: '/existingCustomers',
        loadComponent: lazy(() => import('pages/reservationManagement/existingCustomers')),
      },
      {
        title: '予約コース設定・新規顧客',
        path: '/newCustomers/:id?',
        loadComponent: lazy(() => import('pages/reservationManagement/newCustomers')),
      },
      {
        title: 'アサイン設定',
        path: '/assignSetting',
        loadComponent: lazy(() => import('pages/reservationManagement/assignSetting')),
      },
      {
        title: 'アサイン設定・詳細',
        path: '/assignSetting/detail/:courseId',
        loadComponent: lazy(() => import('pages/reservationManagement/assignSetting/detail')),
      },
      {
        title: '予約メール設定',
        path: '/reservationMailSetting/:orgId?',
        loadComponent: lazy(() => import('pages/reservationManagement/reservationMailSetting')),
      },
    ],
  },
  {
    title: '予約問い合わせ一覧',
    path: '/reservationInquiryList',
    loadComponent: lazy(() => import('pages/reservationInquiryList')),
  },
  {
    title: '本部管理設定',
    path: '/headQuarters',
    loadComponent: lazy(() => import('pages/headQuarters')),
  },
  {
    title: 'エリアマスタ',
    path: '/areaMst',
    loadComponent: lazy(() => import('pages/areaMst')),
  },
  {
    title: '契約状況',
    path: '/contractStatus',
    loadComponent: lazy(() => import('pages/contractStatus')),
    subRoutes: [
      {
        title: '契約内容詳細',
        path: '/detail/:id',
        loadComponent: lazy(() => import('pages/contractStatus/page/Detail')),
        subRoutes: [
          {
            title: '契約有効期限変更',
            path: '/createEditContract',
            loadComponent: lazy(() => import('pages/contractStatus/page/CreateEditContract')),
          },
          {
            title: '解約',
            path: '/cancelContract',
            loadComponent: lazy(() => import('pages/contractStatus/page/Cancel')),
          },
          {
            title: '契約有効期限変更',
            path: '/createEditContract/historyContract/:modifyId',
            loadComponent: lazy(() => import('pages/contractStatus/page/HistoryContract')),
          },
          {
            title: '解約',
            path: '/cancelContract/historyCancel/:cancelId',
            loadComponent: lazy(() => import('pages/contractStatus/page/HistoryCancel')),
          },
        ],
      },
    ],
  },
  {
    title: '定額制契約一覧',
    path: '/listOfFlatRateContracts',
    loadComponent: lazy(() => import('pages/contractFlatRateList')),
    subRoutes: [
      {
        title: '定額制契約申込画面',
        path: '/add',
        loadComponent: lazy(() => import('pages/contractFlatRateList/detail/page/CreateContractFlatRate')),
      },
      {
        title: '定額制契約内容詳細',
        path: '/:id',
        loadComponent: lazy(() => import('pages/contractFlatRateList/detail/page/QuotaSystem')),
      },
    ],
  },
  {
    title: '定額制契約自動作成履歴',
    path: '/flatRateContractAutomaticCreationHistory',
    loadComponent: lazy(() => import('pages/flatRateContractAutomaticCreationHistory')),
  },
  {
    title: '定額制契約自動消化履歴',
    path: '/flatRateContractAutomaticDigestionHistory',
    loadComponent: lazy(() => import('pages/flatRateContractAutomaticDigestionHistory')),
  },
  {
    title: '媒体設定',
    path: '/mediaMaster',
    loadComponent: lazy(() => import('pages/PosMediaMaster')),
  },
  {
    title: '代理店マスタ',
    path: '/agentMaster',
    loadComponent: lazy(() => import('pages/agentMaster')),
    subRoutes: [
      {
        title: '新規代理店登録',
        path: '/add',
        loadComponent: lazy(() => import('pages/agentMaster/add')),
      },
      {
        title: '代理店編集',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/agentMaster/add')),
      },
    ],
  },
  {
    title: 'クリエイティブマスタ',
    path: '/creativeMaster',
    loadComponent: lazy(() => import('pages/creativeMaster')),
    subRoutes: [
      {
        title: '新規クリエイティブ登録',
        path: '/add',
        loadComponent: lazy(() => import('pages/creativeMaster/add')),
      },
      {
        title: 'クリエイティブ編集',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/creativeMaster/add')),
      },
    ],
  },
  {
    title: '効果測定URL発行',
    path: '/mediaPlacement',
    loadComponent: lazy(() => import('pages/mediaPlacement')),
    subRoutes: [
      {
        title: '効果測定用URL新規発行',
        path: '/add',
        loadComponent: lazy(() => import('pages/mediaPlacement/add')),
      },
    ],
  },
  {
    title: '商品部門設定',
    path: '/productDepartment',
    loadComponent: lazy(() => import('pages/commonMasterSetting/productDepartment')),
  },
  {
    title: '媒体小分類設定',
    path: '/mediaSubGroupSetting',
    loadComponent: lazy(() => import('pages/commonMasterSetting/mediaSubCategory')),
  },
  {
    title: '商品設定',
    path: '/productSetting',
    loadComponent: lazy(() => import('pages/commonMasterSetting/productSetting')),
  },
  {
    title: 'レジ基本設定',
    path: '/cashierBasicSetting',
    loadComponent: lazy(() => import('pages/POSHeadquartersSetting/cashierBasicSetting')),
  },
  {
    title: '支払方法設定',
    path: '/paymentMethod',
    loadComponent: lazy(() => import('pages/POSHeadquartersSetting/paymentMethod')),
  },
  {
    title: '税率設定',
    path: '/taxRateSetting',
    loadComponent: lazy(() => import('pages/commonMasterSetting/taxRateSetting')),
  },
  {
    title: 'バーコード印刷',
    path: '/barcodePrinting',
    loadComponent: lazy(() => import('pages/barcodePrinting')),
  },
  {
    title: 'レジ',
    path: '/pos',
    loadComponent: lazy(() => import('pages/pos')),
  },
  {
    title: '精算伝票画面印刷',
    path: '/pos/adjusting/printslip/:nextBusinessDay/:orgId/:orgName/:nextBusinessDayChangeReserve',
    loadComponent: lazy(() => import('pages/pos/adjusting/printSlip')),
    hasNotSidebar: true,
  },
  {
    title: '精算明細画面印刷',
    path: '/pos/adjusting/printslipDetail/:nextBusinessDay/:orgId/:orgName/:nextBusinessDayChangeReserve',
    loadComponent: lazy(() => import('pages/pos/adjusting/printSlipDetail')),
    hasNotSidebar: true,
  },
  {
    title: 'カード会社設定',
    path: '/cardCompanySetting',
    loadComponent: lazy(() => import('pages/POSHeadquartersSetting/cardCompanySetting')),
  },
  {
    title: 'レシートロゴ設定',
    path: '/receiptLogoSetting',
    loadComponent: lazy(() => import('pages/POSHeadquartersSetting/receiptLogoSetting')),
  },
  {
    title: 'レシートCM設定',
    path: '/receiptCMSetting',
    loadComponent: lazy(() => import('pages/POSStoreSettings/receiptCMSetting')),
  },
  {
    title: '値引・割引種別設定',
    path: '/discountType',
    loadComponent: lazy(() => import('pages/commonMasterSetting/discount')),
  },
  {
    title: 'レジ使用店舗設定',
    path: '/cashierStoreSetting',
    loadComponent: lazy(() => import('pages/POSStoreSettings/cashierStoreSetting')),
  },
  {
    title: '営業月報レポート',
    path: '/monthlyReport',
    loadComponent: lazy(() => import('pages/saleManagement/monthlyReport')),
  },
  {
    title: '店舗予算設定',
    path: '/storeBudgeSetting',
    loadComponent: lazy(() => import('pages/saleManagement/storeBudgeSetting')),
  },
  {
    title: '日次集計レポート',
    path: '/dailySummaryReport',
    loadComponent: lazy(() => import('pages/saleManagement/dailySummaryReport')),
  },
  {
    title: '店販品レポート',
    path: '/saleItemsReport',
    loadComponent: lazy(() => import('pages/saleManagement/saleItemsReport')),
  },
  {
    title: '高額利用顧客レポート',
    path: '/vipClientReport',
    loadComponent: lazy(() => import('pages/saleManagement/vipClientReport')),
  },
  {
    title: '未収金一覧',
    path: '/listUncollectedMoney',
    loadComponent: lazy(() => import('pages/saleManagement/listUncollectedMoney')),
  },
  {
    title: '営業月報（リスト）',
    path: '/monthlyBusinessReport',
    loadComponent: lazy(() => import('pages/saleManagement/monthlyBusinessReport')),
  },
  {
    title: '日計レポート',
    path: '/dailyList',
    loadComponent: lazy(() => import('pages/saleManagement/dailyList')),
  },
  {
    title: '広告集計レポート',
    path: '/mediaAgentReport',
    loadComponent: lazy(() => import('pages/mediaAgentReport')),
  },
  {
    title: '広告費入力',
    path: '/mediaAdCost',
    loadComponent: lazy(() => import('pages/mediaAdCost')),
  },
  {
    title: '年度設定',
    path: '/fiscalYearSetting',
    loadComponent: lazy(() => import('pages/fiscalYearSetting')),
  },
  {
    title: '媒体別売上レポート',
    path: '/mediaList',
    loadComponent: lazy(() => import('pages/saleManagement/mediaList')),
  },
  {
    title: '店舗別媒体売上レポート',
    path: '/mediaByStoreList',
    loadComponent: lazy(() => import('pages/saleManagement/mediaByStoreList')),
  },
  {
    title: 'コース別売上レポート',
    path: '/courseListReport',
    loadComponent: lazy(() => import('pages/saleManagement/courseListReport')),
  },
  {
    title: '個人別売上レポート',
    path: '/individualSalesReport',
    loadComponent: lazy(() => import('pages/saleManagement/individualSalesReport')),
  },
  {
    title: '継続率レポート',
    path: '/continuationRateReport',
    loadComponent: lazy(() => import('pages/saleManagement/continuationRateReport')),
  },
  {
    title: 'インセンティブレポート',
    path: '/incentiveReport',
    loadComponent: lazy(() => import('pages/saleManagement/incentiveReport')),
  },
  {
    title: 'ポイント利用レポート',
    path: '/pointUsageReport',
    loadComponent: lazy(() => import('pages/saleManagement/pointUsageReport')),
  },
  {
    title: 'ポイント残高レポート',
    path: '/pointBalanceReport',
    loadComponent: lazy(() => import('pages/saleManagement/pointBalanceReport')),
  },
  {
    title: 'ポイント利用率レポート',
    path: '/pointUseRateReport',
    loadComponent: lazy(() => import('pages/saleManagement/pointUseRateReport')),
  },
  {
    title: '簡易売上シュミレーション',
    path: '/simpleSalesSimulationReport',
    loadComponent: lazy(() => import('pages/saleManagement/simpleSalesSimulationReport')),
  },
  {
    title: '添付シート区分設定',
    path: '/attachedSheetClassificationSetting',
    loadComponent: lazy(() => import('pages/attachedSheetClassificationSetting')),
  },
  {
    title: '仕入先一覧',
    path: '/supplierMaster',
    loadComponent: lazy(() => import('pages/supplierMaster')),
  },
  {
    title: 'ポイント設定',
    path: '/pointSetting',
    loadComponent: lazy(() => import('pages/POSHeadquartersSetting/pointSetting')),
  },
  {
    title: '店販 / 販促一覧',
    path: '/salesAndPromotionList',
    loadComponent: lazy(() => import('pages/inventoryManagement/salesAndPromotionList')),
  },
  {
    title: '業務出荷情報入力',
    path: '/enterInternalExportInformation',
    loadComponent: lazy(() => import('pages/enterInternalExportInformation')),
  },
  {
    title: '入荷情報入力',
    path: '/enterArrivalInformation',
    loadComponent: lazy(() => import('pages/enterArrivalInformation')),
  },
  {
    title: '日計一覧（店舗別）',
    path: '/dailyTotalListByStore',
    loadComponent: lazy(() => import('pages/saleManagement/dailyTotalListByStore')),
  },
  {
    title: 'メールマガジン一覧',
    path: '/maiMagazineList',
    loadComponent: lazy(() => import('pages/mailMagazine')),
    subRoutes: [
      {
        title: 'メールマガジン送信',
        path: '/add',
        loadComponent: lazy(() => import('pages/mailMagazine/page/CreateEditEmail')),
      },
      {
        title: 'メールマガジン送信',
        path: '/history',
        loadComponent: lazy(() => import('pages/mailMagazine/page/HistoryMail')),
      },
    ],
  },
  {
    title: '店舗別在庫一覧',
    path: '/inventoryByStoreList',
    loadComponent: lazy(() => import('pages/inventoryManagement/inventoryByStoreList')),
  },
  {
    title: '在庫一覧',
    path: '/inventoryList',
    loadComponent: lazy(() => import('pages/inventoryManagement/inventoryList')),
  },
  {
    title: '組織略称設定',
    path: '/organizationAbbreviationSetting',
    loadComponent: lazy(() => import('pages/organizationAbbreviationSetting')),
  },
  {
    title: '拡張項目登録',
    path: '/extensionItemRegistration',
    loadComponent: lazy(() => import('pages/extensionItemRegistration')),
    subRoutes: [
      {
        title: '拡張項目編集',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/extensionItemRegistration')),
      },
    ],
  },
  {
    title: '稟議文書マスタ',
    path: '/approvalDocumentMaster',
    loadComponent: lazy(() => import('pages/approvalDocumentMaster')),
    subRoutes: [
      {
        title: '稟議文書マスタ登録',
        path: '/add',
        loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/ApprovalDocumentMasterRegistration')),
      },
      {
        title: '稟議文書マスタ編集',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/ApprovalDocumentMasterRegistration')),
      },
      {
        title: '文書プレビュー',
        path: '/documentPreview/:id?',
        loadComponent: lazy(() => import('pages/approvalDocumentMaster/components/documentPreview')),
      },
    ],
  },

  {
    title: '拡張情報選択・表示順変更',
    path: '/changeExtendInfo',
    loadComponent: lazy(() => import('pages/approvalDocumentMaster/components/changeExtendInfo')),
  },
  {
    title: '申請ルートマスタ',
    path: '/applicationRoute',
    loadComponent: lazy(() => import('pages/application')),
    subRoutes: [
      {
        title: '申請ルート登録',
        path: '/:type/:id?',
        loadComponent: lazy(() => import('pages/application')),
      },
    ],
  },
  {
    title: '新規申請',
    path: '/applicationDocument',
    loadComponent: lazy(() => import('pages/application/applicationDocument')),
    subRoutes: [
      {
        title: '申請ルート登録',
        path: '/add',
        loadComponent: lazy(() => import('pages/application/applicationRouteRegistration')),
      },
      {
        title: '申請ルート登録',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/application/applicationRouteRegistration')),
      },
      {
        title: '再申請',
        path: '/reApply/:id',
        loadComponent: lazy(() => import('pages/application/reApply')),
      },
      {
        title: '申請文書参照',
        path: '/reference/:id',
        loadComponent: lazy(() => import('pages/application/applicationDocument/reference')),
      },
      {
        title: '承認・否決・差戻',
        path: '/acknowledgmentDenialDismissal/:id',
        loadComponent: lazy(() => import('pages/application/applicationDocument/acknowledgmentDenialDismissal')),
      },
      {
        title: '申請文書印刷',
        path: '/print/:id',
        loadComponent: lazy(() => import('pages/application/applicationDocument/print')),
        hasNotSidebar: true,
      },
    ],
  },
  {
    title: '拡張情報登録',
    path: '/extendedInformation',
    loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/ExtendedInformationRegistration')),
    subRoutes: [
      {
        title: '拡張情報編集',
        path: '/edit/:id',
        loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/ExtendedInformationRegistration')),
      },
    ],
  },
  {
    title: 'ルート割当',
    path: '/approvalRouteAssignment',
    loadComponent: lazy(() => import('pages/approvalRouteAssignment')),
  },
  {
    title: '稟議文書詳細検索',
    path: '/approvalDocumentList/advancedSearch/:id?',
    loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/approvalDocumentList/advancedSearch')),
  },
  {
    title: '稟議文書一覧',
    path: '/approvalDocumentList',
    loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/approvalDocumentList')),
  },
  {
    title: '要申請一覧',
    path: '/requiredApplicationList',
    loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/commonList')),
  },
  {
    title: '要承認一覧',
    path: '/admitApplicationList',
    loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/commonList')),
  },
  {
    title: '結果一覧',
    path: '/resultList',
    loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/commonList')),
  },
  {
    title: '参照一覧',
    path: '/applicationApprovalReferenceList',
    loadComponent: lazy(() => import('pages/ApprovalDocumentGroup/commonList')),
  },
  {
    title: '反響情報拡張設定',
    path: '/customerReverberationInfoExSetting',
    loadComponent: lazy(() => import('pages/customerReverberationInfoExpansionSetting')),
  },
  {
    title: 'シフト表',
    path: '/shiftManagement',
    loadComponent: lazy(() => import('pages/shiftManagement')),
  },
  {
    title: '一括登録',
    path: '/shiftBulkRegistration',
    loadComponent: lazy(() => import('pages/shiftBulkRegistration')),
  },
  {
    title: 'エクスポート処理',
    path: '/shiftBulkRegistration/exportProcessing',
    loadComponent: lazy(() => import('pages/shiftBulkRegistration/exportProcessing')),
  },
  {
    title: 'インポート処理',
    path: '/shiftBulkRegistration/importProcessing',
    loadComponent: lazy(() => import('pages/shiftBulkRegistration/importProcessing')),
  },
  {
    title: 'シフトパターン',
    path: '/shiftPattern',
    loadComponent: lazy(() => import('pages/shiftPattern')),
  },
];
